/**
 * reducedMotion.ts — prefers-reduced-motion detection (task C02).
 *
 * The snow scene reduces to a static layer when the user prefers reduced
 * motion, and reacts live to preference changes.
 */
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** Current preference (false when matchMedia is unavailable). */
export function readPrefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(REDUCED_MOTION_QUERY).matches;
}

/**
 * Subscribes to preference changes. Returns an unsubscribe function.
 * The callback is NOT invoked for the initial state — read that separately
 * with readPrefersReducedMotion().
 */
export function subscribeReducedMotion(callback: (reduced: boolean) => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return () => {};
  }
  const mql = window.matchMedia(REDUCED_MOTION_QUERY);
  const onChange = (event: MediaQueryListEvent): void => {
    callback(event.matches);
  };
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}
